import script from "./QuestionCard2.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionCard2.vue?vue&type=script&setup=true&lang=js"

import "./QuestionCard2.vue?vue&type=style&index=0&id=64259eed&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64259eed"]])

export default __exports__